import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { QRCodeSVG } from 'qrcode.react';

const apiUrl = process.env.REACT_APP_API_URL;
const markAttendanceBaseUrl = `${window.location.origin}/mark-attendance`;

function AttendanceQRModal({ onClose }) {
  const [active, setActive] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const fetchActive = useCallback(async () => {
    setLoading(true);
    setError('');
    try {
      const sessionData = JSON.parse(sessionStorage.getItem('studentSession'));
      const response = await axios.get(`${apiUrl}/api/student/attendance-qr/active`, {
        headers: { Authorization: `Bearer ${sessionData?.token}` },
      });
      if (response.data.success) {
        setActive(response.data.active || null);
      } else {
        setError(response.data.message || 'Failed to load QR code.');
      }
    } catch (err) {
      setError(err.response?.data?.message || 'Error loading QR code.');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchActive();
  }, [fetchActive]);

  const qrValue = active ? `${markAttendanceBaseUrl}?token=${active.token}` : '';

  return (
    <div
      role="dialog"
      aria-modal="true"
      style={{
        position: 'fixed', inset: 0, background: 'rgba(3,9,23,0.55)', zIndex: 2000,
        display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20,
      }}
      onClick={onClose}
    >
      <div
        style={{
          background: '#fff', borderRadius: 20, padding: '32px 28px', maxWidth: 380, width: '100%',
          textAlign: 'center', position: 'relative',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <button
          type="button"
          onClick={onClose}
          aria-label="Close"
          style={{
            position: 'absolute', top: 12, right: 12, border: 'none', background: 'transparent',
            fontSize: 20, cursor: 'pointer', color: '#667',
          }}
        >
          <i className="ph ph-x" />
        </button>
        <h5 className="fw-bold mb-8">Attendance QR Code</h5>
        <p className="text-13 text-gray-500 mb-16">
          Scan this with your phone's camera, then type your student ID number to mark today's attendance.
        </p>
        {loading ? (
          <div className="py-40"><div className="spinner-border text-main-600" /></div>
        ) : error ? (
          <div className="alert alert-danger">{error}</div>
        ) : active ? (
          <div style={{ padding: 20, background: '#fff', border: '1px solid #e8f5ee', borderRadius: 16, display: 'inline-block' }}>
            <QRCodeSVG value={qrValue} size={220} />
          </div>
        ) : (
          <p className="text-gray-400 py-20">No QR code has been generated by the admin yet.</p>
        )}
      </div>
    </div>
  );
}

export default AttendanceQRModal;
